/* @flow */
import createChainedFunction from 'utils/createChainedFunction';
import { getPropClassesFromInstance } from 'lib/getPropClasses';
import React from 'react';
import ReactDOM from 'react-dom';

import cx from 'classnames';
import './styles/Text.scss';

class Text extends React.Component {
  static propTypes = {
    align: React.PropTypes.oneOf([
      'left',
      'center',
      'right',
      'inherit',
    ]),
    color: React.PropTypes.oneOf([
      'pitch',
      'thunder',
      'eclipse',
      'sunrise',
      'koala',
      'lava',
      'white',
      'violet',
      'midnight',
      'wolf',
      'brand',
      'shamrock',
      'jungle',
      'flame',
      'brand',
      'inherit',
    ]),
    lineHeight: React.PropTypes.oneOf([
      'medium',
      'large',
    ]),
    size: React.PropTypes.oneOf([
      'xxxxxsmall',
      'xxxxsmall',
      'xxxsmall',
      'xxsmall',
      'xsmall',
      'small',
      'medium',
      'large',
      'xlarge',
      'xxlarge',
      'xxxlarge',
      'xxxxlarge',
    ]),
    weight: React.PropTypes.oneOf([
      'bold',
      'semibold',
      'normal',
      'light',
    ]),
    element: React.PropTypes.oneOf([
      'h1',
      'h2',
      'h3',
      'h4',
      'p',
      'div',
      'span',
    ]),
    truncate: React.PropTypes.bool,
    italic: React.PropTypes.bool,
    uppercase: React.PropTypes.bool,
    capitalize: React.PropTypes.bool,
    wrap: React.PropTypes.bool,
    onMouseOver: React.PropTypes.func,
    'data-test-selector': React.PropTypes.string,
  };

  static propClasses = {
    align: {
      left: 'Text--left',
      center: 'Text--center',
      right: 'Text--right',
    },
    color: {
      pitch: 'Text-pitch',
      thunder: 'Text-thunder',
      eclipse: 'Text-eclipse',
      koala: 'Text-koala',
      sunrise: 'Text-sunrise',
      lava: 'Text-lava',
      white: 'Text-white',
      midnight: 'Text-midnight',
      wolf: 'Text-wolf',
      violet: 'Text-violet',
      shamrock: 'Text-shamrock',
      jungle: 'Text-jungle',
      flame: 'Text-flame',
      brand: 'Text-brand',
    },
    lineHeight: {
      medium: 'Text--lineHeightMedium',
      large: 'Text--lineHeightLarge',
    },
    size: {
      xxxxxsmall: 'Text-sizeXxxxxSmall',
      xxxxsmall: 'Text-sizeXxxxSmall',
      xxxsmall: 'Text-sizeXxxSmall',
      xxsmall: 'Text-sizeXxSmall',
      xsmall: 'Text-sizeXSmall',
      small: 'Text-sizeSmall',
      medium: 'Text-sizeMedium',
      large: 'Text-sizeLarge',
      xlarge: 'Text-sizeXLarge',
      xxlarge: 'Text-sizeXxLarge',
      xxxlarge: 'Text-sizeXxxLarge',
      xxxxlarge: 'Text-sizeXxxxLarge',
    },
    weight: {
      bold: 'Text-weightBold',
      semibold: 'Text-weightSemibold',
      normal: 'Text-weightNormal',
      light: 'Text-weightLight',
    },
    truncate: 'Text-truncate',
    uppercase: 'Text-uppercase',
    capitalize: 'Text-capitalize',
    italic: 'Text-italic',
  };

  static defaultProps = {
    align: 'inherit',
    element: 'span',
    truncate: false,
    uppercase: false,
    wrap: true,
  };

  state = {
    label: '',
  };

  handleMouseOver = () => {
    if (!this.props.truncate) {
      return;
    }
    const container = ReactDOM.findDOMNode(this);
    const visibleWidth = container.getBoundingClientRect().width;
    const textWidth = container.childNodes[0].getBoundingClientRect().width;
    if (textWidth > visibleWidth) {
      this.setState({ label: container.textContent });
    } else {
      this.setState({ label: '' });
    }
  };

  render() {
    const { className, onMouseOver, children } = this.props;
    const Component = this.props.element || 'span';

    return (
      <Component
        data-test-selector={this.props['data-test-selector']}
        className={cx('Text', getPropClassesFromInstance(this), {
          'Text-noWrap': !this.props.wrap,
        }, className)}
        title={this.state.label}
        onClick={this.props.onClick}
        onMouseOver={createChainedFunction(this.handleMouseOver, onMouseOver)}>
        {this.props.truncate ? <span>{children}</span> : children}
      </Component>
    );
  }
}

export default Text;



// WEBPACK FOOTER //
// ./src/components/Text.jsx